const styles = (theme) => ({
    transition: {
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    paperAnchor: {
      position: "absolute",
      overflowX: "hidden",
      boxShadow: "none",
      width: 380,
      boxSizing: "border-box",
      backgroundColor: theme.gridBGColor,
      transform: "translate(0px, 0px)",
      transition: theme.transitions.create(["width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    paperHidden: {
      height: 0,
      width: 0,
    },
    applyDrawerShadow: {
      boxShadow: "none",
    },
    drawerPaper: {
      marginTop: "55px",
      height: "87%",
    },
    backdrop: {
      position: "absolute",
      backgroundColor: "transparent",
    },
    nonTransparentBackdrop: {
      position: "absolute",
    },
    modal: {
      position: "absolute",
    },
  });
  
  export default styles;
  